import { useEffect } from 'react';

// مكون بسيط لإدارة هوية النادي
const ClubIdentityManager = ({ clubSettings, clubBasicInfo }) => {
  
  useEffect(() => {
    if (clubSettings || clubBasicInfo) {
      const clubName = clubSettings?.club_name || clubBasicInfo?.club_name || 'النادي الرياضي';
      
      // 1. تحديث عنوان الصفحة
      document.title = `${clubName} - الموقع الرسمي`;
      
      // 2. إطلاق event لتحديث المكونات الأخرى
      window.dispatchEvent(new CustomEvent('clubNameUpdated', {
        detail: { club_name: clubName }
      }));
      
      console.log(`📝 تم تحديث هوية النادي: ${clubName}`);
    }
  }, [clubSettings, clubBasicInfo]);

  // المكون لا يرسل أي UI - فقط side effects
  return null;
};

export default ClubIdentityManager;